import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propBool, propShape } from '../../../../helpers/custom-prop-types';
import BlurText from '../../../Ui/Common/BlurText';
import SplitText from '../../../Ui/Common/SplitText';
const SectionProjectOne = (props) => {
    const { isBlur, record } = props;
    const renderFunc = useCallback((row) => (_jsx(BlurText, Object.assign({ component: 'span', isBlur: isBlur }, { children: row }))), [isBlur]);
    return (_jsxs("div", Object.assign({ className: 'about-consultant-project-row' }, { children: [_jsx("h3", { children: record.title }), record.middleTasks.length > 0 && (_jsx("ul", { children: record.middleTasks.map((middleTask) => (_jsx("li", { children: _jsx(BlurText, Object.assign({ component: 'span', isBlur: isBlur }, { children: middleTask.name })) }, middleTask.id))) })), _jsx(SplitText, { renderFunc: renderFunc, text: record.content, wrap: 'p' })] })));
};
SectionProjectOne.propTypes = {
    isBlur: propBool().isRequired,
    record: propShape(),
};
SectionProjectOne.defaultProps = {
    record: {},
};
export default SectionProjectOne;
